import { A11yModule } from '@angular/cdk/a11y';
import { NgSwitch, NgSwitchCase, SlicePipe, TitleCasePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogRef as MatDialogRef, MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { ProfileDetailsType } from '@shared/models/profile-details-type';
import * as MemberProfileStore from '@shared/store/member-profile';
import { NameWithoutTitlePipe } from '@shared/pipes/nameWithoutTitle.pipe';

@Component({
  selector: 'ten-delete-popup',
  templateUrl: './delete-popup.component.html',
  styleUrls: ['./delete-popup.component.scss'],
  standalone: true,
  imports: [
    NgSwitch,
    NgSwitchCase,
    MatLegacyDialogModule,
    TranslateModule,
    TitleCasePipe,
    SlicePipe,
    MatLegacyButtonModule,
    A11yModule,
    NameWithoutTitlePipe,
  ],
})
export class DeletePopupComponent {
  @Input() public pastDataId?: any;
  @Input() public data?: any;
  @Output() public closed = new EventEmitter<any>();

  public ProfileDetailsType = ProfileDetailsType;
  protected translationKeys = {
    phoneNumber: {
      home: 'PhoneNumberFormComponent:Home',
      mobile: 'PhoneNumberFormComponent:Mobile',
      work: 'PhoneNumberFormComponent:Work',
      other: 'PhoneNumberFormComponent:Other',
    },
    address: {
      home: 'AddressFormComponent:Home',
      work: 'AddressFormComponent:Work',
      holiday_home: 'AddressFormComponent:HolidayHome',
      other: 'AddressFormComponent:Other',
    },
    traveller: {
      adult: 'BookingCard:AdultTag',
      Adult: 'BookingCard:AdultTag',
      young_adult: 'BookingCard:YoungAdultTag',
      YoungAdult: 'BookingCard:YoungAdultTag',
      child: 'BookingCard:ChildTag',
      Child: 'BookingCard:ChildTag',
      infant: 'BookingCard:InfantTag',
      Infant: 'BookingCard:InfantTag',
    },
    specialOccasion: {
      anniversary: 'SpecialFormComponent:Anniversary',
      birthday: 'SpecialFormComponent:Birthday',
      one_off: 'SpecialFormComponent:One_off',
      yearly_recurring: 'SpecialFormComponent:Yearly_recurring',
    },
    paymentCard: 'ProfileCard:Last4Digits',
  };

  constructor(
    public dialogRef: MatDialogRef<DeletePopupComponent>,
    private ngrxStore: Store<MemberProfileStore.MemberProfileState>
  ) {}

  public removeAndClose() {
    switch (this.data.form_type) {
      case ProfileDetailsType.PhoneNumber:
        this.ngrxStore.dispatch(new MemberProfileStore.DestroyProfilePhoneNumber(this.pastDataId));
        break;
      case ProfileDetailsType.Address:
        this.ngrxStore.dispatch(new MemberProfileStore.DestroyProfileAddress(this.pastDataId));
        break;
      case ProfileDetailsType.Traveller:
        this.ngrxStore.dispatch(new MemberProfileStore.DestroyProfileTraveller(this.pastDataId));
        break;
      case ProfileDetailsType.SpecialOccasion:
        this.ngrxStore.dispatch(new MemberProfileStore.DestroyProfileSpecialOccasion(this.pastDataId));
        break;
      case ProfileDetailsType.PaymentCard:
        this.ngrxStore.dispatch(new MemberProfileStore.DestroyProfilePaymentCard(this.pastDataId));
        break;
      default:
        break;
    }

    this.closeForm();
  }

  public onNoClick() {
    this.dialogRef.close();
  }

  public closeForm() {
    this.closed.emit();
  }
}
